/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  PsNotes,
  ErrorInfo,
  BinaryFile,
  PostPsNoteDownloadBody,
  GetPsNote200,
  PostPsNoteAddBody
} from '.././model'


/**
 * 制作管理IDに紐付くPS改廃案メモ一覧を取得する。

 * @summary PS改廃案メモ一覧取得
 */
export const getPsNoteList = (
    productionId: number,
    chapterNumberId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsNotes>> => {
    return axios.get(
      `/psnotes/list/${productionId}/${chapterNumberId}`,options
    );
  }


export const getGetPsNoteListQueryKey = (productionId: number,
    chapterNumberId: string,) => [`/psnotes/list/${productionId}/${chapterNumberId}`];

    
export type GetPsNoteListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsNoteList>>>
export type GetPsNoteListQueryError = AxiosError<ErrorInfo>

export const useGetPsNoteList = <TData = Awaited<ReturnType<typeof getPsNoteList>>, TError = AxiosError<ErrorInfo>>(
 productionId: number,
    chapterNumberId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsNoteList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsNoteListQueryKey(productionId,chapterNumberId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsNoteList>>> = ({ signal }) => getPsNoteList(productionId,chapterNumberId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsNoteList>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId && chapterNumberId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 制作管理IDに紐付くPS改廃案メモ一覧をExcel形式でダウンロードする。

 * @summary PS改廃案メモ一覧ダウンロード
 */
export const postPsNoteDownload = (
    productionId: number,
    postPsNoteDownloadBody: PostPsNoteDownloadBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/psnotes/list/${productionId}/download`,
      postPsNoteDownloadBody,options
    );
  }



    export type PostPsNoteDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postPsNoteDownload>>>
    export type PostPsNoteDownloadMutationBody = PostPsNoteDownloadBody
    export type PostPsNoteDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostPsNoteDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsNoteDownload>>, TError,{productionId: number;data: PostPsNoteDownloadBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsNoteDownload>>, {productionId: number;data: PostPsNoteDownloadBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postPsNoteDownload(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsNoteDownload>>, TError, {productionId: number;data: PostPsNoteDownloadBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS改廃案メモ新規追加ダイアログ用データ表示

 * @summary PS改廃案メモ新規追加ダイアログ用データ表示
 */
export const getPsNote = (
    psDerivationId: number,
    chapterId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPsNote200>> => {
    return axios.get(
      `/psnotes/${psDerivationId}/${chapterId}`,options
    );
  }


export const getGetPsNoteQueryKey = (psDerivationId: number,
    chapterId: number,) => [`/psnotes/${psDerivationId}/${chapterId}`];

    
export type GetPsNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getPsNote>>>
export type GetPsNoteQueryError = AxiosError<ErrorInfo>

export const useGetPsNote = <TData = Awaited<ReturnType<typeof getPsNote>>, TError = AxiosError<ErrorInfo>>(
 psDerivationId: number,
    chapterId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsNote>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsNoteQueryKey(psDerivationId,chapterId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsNote>>> = ({ signal }) => getPsNote(psDerivationId,chapterId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsNote>>, TError, TData>(queryKey, queryFn, {enabled: !!(psDerivationId && chapterId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 指定PSとその配下の全てのPSに紐付くPS改廃案メモ一覧取得

 * @summary PS改廃案メモ一覧取得(PS指定)
 */
export const getPsNotePsList = (
    psVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsNotes>> => {
    return axios.get(
      `/psnotes/pslist/${psVersionId}`,options
    );
  }


export const getGetPsNotePsListQueryKey = (psVersionId: number,) => [`/psnotes/pslist/${psVersionId}`];

    
export type GetPsNotePsListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsNotePsList>>>
export type GetPsNotePsListQueryError = AxiosError<ErrorInfo>

export const useGetPsNotePsList = <TData = Awaited<ReturnType<typeof getPsNotePsList>>, TError = AxiosError<ErrorInfo>>(
 psVersionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsNotePsList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsNotePsListQueryKey(psVersionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsNotePsList>>> = ({ signal }) => getPsNotePsList(psVersionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsNotePsList>>, TError, TData>(queryKey, queryFn, {enabled: !!(psVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃案メモを新規追加する。

 * @summary PS改廃案メモ新規追加
 */
export const postPsNoteAdd = (
    postPsNoteAddBody: PostPsNoteAddBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/psnotes/add`,
      postPsNoteAddBody,options
    );
  }



    export type PostPsNoteAddMutationResult = NonNullable<Awaited<ReturnType<typeof postPsNoteAdd>>>
    export type PostPsNoteAddMutationBody = PostPsNoteAddBody
    export type PostPsNoteAddMutationError = AxiosError<ErrorInfo>

    export const usePostPsNoteAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsNoteAdd>>, TError,{data: PostPsNoteAddBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsNoteAdd>>, {data: PostPsNoteAddBody}> = (props) => {
          const {data} = props ?? {};

          return  postPsNoteAdd(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsNoteAdd>>, TError, {data: PostPsNoteAddBody}, TContext>(mutationFn, mutationOptions)
    }
    